import { render, staticRenderFns } from "./frontGenerator.vue?vue&type=template&id=70b78007"
import script from "./frontGenerator.vue?vue&type=script&lang=js"
export * from "./frontGenerator.vue?vue&type=script&lang=js"
import style0 from "./frontGenerator.vue?vue&type=style&index=0&id=70b78007&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports